import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { Button, FlexibleModal, TextInput } from 'components'
import ApiHelper from 'helpers/ApiHelper'

const CreateDanalockModal = ({ visible, toggle }) => {
  const { t } = useTranslation()
  const [form, setForm] = useState({})

  //  --- Functionality ---
  const closeModal = () => {
    setForm({})
    toggle()
  }

  const createObject = async () => {
    await toast.promise(ApiHelper.createObject(form, 'danalock'), {
      loading: 'Creating New Lock Object.',
      success: 'Lock created.',
      error: 'Lock could not be created.',
    })

    closeModal()
  }

  //  --- Response ---
  return (
    <FlexibleModal size="modal-md" visible={visible}>
      <div className="flex flex-col space-y-4">
        <div className="flex flex-col space-y-4">
          <label className="flex justify-between">
            <p className="my-auto">Serial Number</p>
            <TextInput
              className="w-2/3"
              onChange={(e) =>
                setForm((f) => ({ ...f, SerialNumber: e.target.value }))
              }
              value={form.SerialNumber}
            />
          </label>
          <label className="flex justify-between">
            <p className="my-auto">Name</p>
            <TextInput
              className="w-2/3"
              onChange={(e) => setForm((f) => ({ ...f, Name: e.target.value }))}
              value={form.Name}
            />
          </label>
          <label className="flex justify-between">
            <p className="my-auto">Device Type</p>
            <TextInput
              className="w-2/3"
              onChange={(e) =>
                setForm((f) => ({ ...f, DeviceType: e.target.value }))
              }
              value={form.DeviceType}
            />
          </label>
          <label className="flex justify-between">
            <p className="my-auto">Username</p>
            <TextInput
              className="w-2/3"
              onChange={(e) =>
                setForm((f) => ({ ...f, UserName: e.target.value }))
              }
              value={form.UserName}
            />
          </label>
          <label className="flex justify-between">
            <p className="my-auto">Password</p>
            <TextInput
              className="w-2/3"
              onChange={(e) =>
                setForm((f) => ({ ...f, Password: e.target.value }))
              }
              value={form.Password}
            />
          </label>
        </div>
        <div className="flex flex-row justify-end space-x-4">
          <Button
            className="border border-red-200 bg-white text-red-500 hover:border-red-500 hover:bg-red-500 hover:text-white"
            onClick={closeModal}
          >
            {t('application:cancel')}
          </Button>
          <Button
            className="bg-green-400 text-white hover:bg-green-500"
            onClick={createObject}
          >
            {t('application:submit')}
          </Button>
        </div>
      </div>
    </FlexibleModal>
  )
}

export default CreateDanalockModal
